import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslocoService } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgxFileDropModule } from 'ngx-file-drop';

@Component({
	selector: 'app-party-setup',
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		NgxFileDropModule
	],
	templateUrl: './party-setup.component.html',
	styleUrls: ['./party-setup.component.css'],
	animations: [
		trigger('isVisible', [
			state('visible', style({
				opacity: 1
			})),
			state('invisible', style({
				opacity: 0
			})),
			transition('visible => invisible', [
				animate('0.5s')
			]),
			transition('invisible => visible', [
				animate('1s')
			])
		])
	],
})
export class PartySetupComponent implements OnInit {
	isFormMode: boolean = false;
	formPosition: number = 0;

	// FORM SUBMISSION ELEMENTS

	constructor(public translate: TranslocoService) { }

	ngOnInit(): void {
	}

	public eventTitle: string;
	public dateAndTime: string;
	public location: string;
	/*
	Host object:
		- name
		- profile picture
		- contact info: email/phone number
	*/
	public hostName: string;
	/*
	Full guestlist should contain (optional): (as guest object)
		- guest name
		- profile picture (not required)
	*/
	public guestList: string[];
	/*
	Correct restaurant list should contain:
		- restaurant image
		- restaurant logo
		- restaurant name
	*/
	public restaurantList: string[];
	public eventNotes: string[];

	// Google maps components
	public center: google.maps.LatLng;

	startPartyForm() {
		this.isFormMode = true;
	}

	nextStep(position: number) {
		if (this.formPosition == position) {
			this.formPosition++;
		}
	}
}
